var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b;
import { InternalTagType, TagType } from '@common/api';
import { TagNameDisplay } from '@data/types';
import { isAccountTag, } from './types';
var TAG_TYPE_NAME_MAP = (_a = {},
    _a[TagType.Account] = 'Variable',
    _a[TagType.Dimension] = 'Dimension',
    _a[TagType.Group] = 'Group',
    _a[TagType.Table] = 'Table',
    _a);
var TAG_INTERNAL_TYPE_NAME_MAP = (_b = {},
    _b[InternalTagType.Version] = 'Version',
    _b[InternalTagType.Year] = 'Year',
    _b[InternalTagType.Month] = 'Month',
    _b[InternalTagType.Quarter] = 'Quarter',
    _b[InternalTagType.HalfYear] = 'Half Year',
    _b[InternalTagType.YearToDate] = 'Year to Date',
    _b);
export function getTagTypeName(item) {
    return TAG_TYPE_NAME_MAP[item.type];
}
export function getTagInternalTypeName(item) {
    return TAG_INTERNAL_TYPE_NAME_MAP[item.internalType];
}
export function getTagDisplayName(tag) {
    return tag.name;
}
export function getTagExpression(tag) {
    var tagName = getTagDisplayName(tag);
    if (!tagName.match(/^[a-zA-Z|ž|š|đ|č|ć][\w| |ž|š|đ|č|ć]+$/)) {
        return "\"".concat(tagName, "\"");
    }
    return tagName;
}
export function getTagLongName(tag, rowNameDisplay) {
    if ((!rowNameDisplay || rowNameDisplay === TagNameDisplay.Both) && tag.description && tag.description !== '') {
        return "".concat(getTagDisplayName(tag), " ").concat(tag.description);
    }
    else if (rowNameDisplay &&
        rowNameDisplay === TagNameDisplay.Description &&
        tag.description &&
        tag.description !== '') {
        return tag.description;
    }
    else {
        return getTagDisplayName(tag);
    }
}
export function getTagLowercaseName(tag) {
    var tagName = getTagDisplayName(tag);
    return tagName.toLowerCase().trim();
}
// removes "" from tag references, converts to lowercase
export function getCannonicalTagName(identifierImage) {
    var cannoicalTagName = identifierImage.toLowerCase().trim();
    if (identifierImage.startsWith('"') && identifierImage.endsWith('"')) {
        cannoicalTagName = cannoicalTagName.substring(1, cannoicalTagName.length - 1);
    }
    return cannoicalTagName;
}
export function getTimeDimensionName(tag) {
    switch (tag.internalType) {
        case InternalTagType.Month:
        case InternalTagType.Year:
            return tag.description && tag.description !== '' ? "".concat(tag.description) : "".concat(tag.name.substring(1));
        case InternalTagType.YearToDate:
            return tag.description && tag.description !== '' ? "".concat(tag.description) : "YTD-".concat(tag.order);
        default:
            return tag.description && tag.description !== '' ? "".concat(tag.description) : "".concat(tag.name);
    }
}
export function getTimeDimensionTagsFromDate(date, internalTagsMap, offset) {
    if (offset === void 0) { offset = 0; }
    var dateCopy = new Date(date);
    if (offset) {
        dateCopy.setMonth(dateCopy.getMonth() - offset);
    }
    var month = dateCopy.getMonth() + 1;
    var year = dateCopy.getFullYear();
    var yearTag = internalTagsMap.years.find(function (y) { return y.name === 'Y' + year; });
    var monthTag = internalTagsMap.months.find(function (m) { return m.name === 'M' + month; });
    if (!monthTag || !yearTag) {
        throw new Error('Date is not in range');
    }
    return { yearTag: yearTag, monthTag: monthTag };
}
export function getConnectedAccTagsWithDiffDimensions(accTag, dependencies) {
    var e_1, _a;
    var tagMap = dependencies.tagMap;
    if (accTag.connectedTagIds === undefined || accTag.connectedTagIds.length === 0) {
        return undefined;
    }
    var diffDimensionAccountTags = [];
    var _loop_1 = function (cId) {
        var connectedTag = tagMap[cId];
        if (!isAccountTag(connectedTag)) {
            return "continue";
        }
        if (accTag.dimensionTagIds.some(function (id) { return !connectedTag.dimensionTagIds.includes(id); }) ||
            connectedTag.dimensionTagIds.some(function (id) { return !accTag.dimensionTagIds.includes(id); })) {
            diffDimensionAccountTags.push(connectedTag);
        }
    };
    try {
        for (var _b = __values(accTag.connectedTagIds), _c = _b.next(); !_c.done; _c = _b.next()) {
            var cId = _c.value;
            _loop_1(cId);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return diffDimensionAccountTags.length === 0 ? undefined : diffDimensionAccountTags;
}
export function getFixatedTagsConnectedToDimensionsMap(accTag, dependencies) {
    var e_2, _a;
    var tagMap = dependencies.tagMap, relationMap = dependencies.relationMap;
    if (accTag.connectedTagIds === undefined || accTag.connectedTagIds.length === 0) {
        return undefined;
    }
    var dimensionsByTableTagIdMap = new Map();
    var _loop_2 = function (cId) {
        var e_3, _d;
        var connectedTag = tagMap[cId];
        if (!connectedTag) {
            throw new Error("One of the set connected tags does not exist on variable \"".concat(accTag.name, "\""));
        }
        if (connectedTag.type !== TagType.Dimension || connectedTag.ParentId === null) {
            return "continue";
        }
        var connectedTagTable = tagMap[connectedTag.ParentId];
        if (connectedTagTable === undefined) {
            return "continue";
        }
        var _loop_3 = function (dId) {
            var setTableTag = tagMap[dId];
            if (!setTableTag) {
                throw new Error("One of the set dimension does not exist on variable \"".concat(accTag.name, "\""));
            }
            if (dId === connectedTagTable.id) {
                var dimensionTags = dimensionsByTableTagIdMap.get(setTableTag.id);
                if (!dimensionTags) {
                    dimensionTags = [];
                }
                dimensionTags.push(connectedTag);
                dimensionsByTableTagIdMap.set(setTableTag.id, dimensionTags);
            }
            var connRelations = relationMap[connectedTagTable.id];
            var setTableRelations = relationMap[setTableTag.id];
            if (!(connRelations || setTableRelations)) {
                return "continue";
            }
            if ((connRelations === null || connRelations === void 0 ? void 0 : connRelations.some(function (r) { return r.tableTagId === setTableTag.id || r.connectedTableTagId === setTableTag.id; })) ||
                (setTableRelations === null || setTableRelations === void 0 ? void 0 : setTableRelations.some(function (r) { return r.tableTagId === connectedTagTable.id || r.connectedTableTagId === connectedTagTable.id; }))) {
                var dimensionTags = dimensionsByTableTagIdMap.get(setTableTag.id);
                if (!dimensionTags) {
                    dimensionTags = [];
                }
                dimensionTags.push(connectedTag);
                dimensionsByTableTagIdMap.set(setTableTag.id, dimensionTags);
            }
        };
        try {
            for (var _e = (e_3 = void 0, __values(accTag.dimensionTagIds)), _f = _e.next(); !_f.done; _f = _e.next()) {
                var dId = _f.value;
                _loop_3(dId);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_d = _e.return)) _d.call(_e);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    try {
        for (var _b = __values(accTag.connectedTagIds), _c = _b.next(); !_c.done; _c = _b.next()) {
            var cId = _c.value;
            _loop_2(cId);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return dimensionsByTableTagIdMap.size === 0 ? undefined : dimensionsByTableTagIdMap;
}
export function getTagParents(tag, tagMap) {
    var _a;
    var getParents = function (tag, parents) {
        if (parents === void 0) { parents = []; }
        var parent = tag.ParentId ? tagMap[tag.ParentId] : null;
        if (parent === undefined) {
            return parents;
        }
        if (parent === null) {
            return __spreadArray(__spreadArray([], __read(parents), false), [parent], false);
        }
        parents.push(parent);
        return getParents(parent, parents);
    };
    var parents = (_a = getParents(tag)) !== null && _a !== void 0 ? _a : [];
    return parents.reverse();
}
export function eachTagChild(tag, visit, dependencies) {
    var e_4, _a;
    var tagsByParentId = dependencies.tagsByParentId;
    var children = tagsByParentId[tag.id];
    if (!children) {
        return;
    }
    try {
        for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
            var child = children_1_1.value;
            var shouldVisitChildren = visit(child);
            if (shouldVisitChildren === false) {
                continue;
            }
            eachTagChild(child, visit, dependencies);
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
        }
        finally { if (e_4) throw e_4.error; }
    }
}
